module.exports = `${require.publicPath}banner-bg.f9a8606a.png`;